import { render, staticRenderFns } from "./AdminCommunicationComposer.vue?vue&type=template&id=04793604&scoped=true&"
import script from "./AdminCommunicationComposer.vue?vue&type=script&lang=js&"
export * from "./AdminCommunicationComposer.vue?vue&type=script&lang=js&"
import style0 from "./AdminCommunicationComposer.vue?vue&type=style&index=0&id=04793604&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04793604",
  null
  
)

export default component.exports